export type FrontPaymentMode = 'disabled' | 'mock' | 'live';
export type FrontAuthMode = 'none' | 'kakao' | 'google';

function parsePaymentMode(rawMode: string | undefined): FrontPaymentMode {
  if (rawMode === 'mock' || rawMode === 'live' || rawMode === 'disabled') {
    return rawMode;
  }
  return 'disabled';
}

function parseAuthMode(rawMode: string | undefined): FrontAuthMode {
  if (rawMode === 'kakao' || rawMode === 'google' || rawMode === 'none') {
    return rawMode;
  }
  return 'none';
}

export const APP_RUNTIME = {
  paymentMode: parsePaymentMode(import.meta.env.VITE_PAYMENT_MODE),
  authMode: parseAuthMode(import.meta.env.VITE_AUTH_MODE),
} as const;

export const APP_FEATURES = {
  paymentEnabled: APP_RUNTIME.paymentMode !== 'disabled',
  kakaoLoginEnabled: APP_RUNTIME.authMode === 'kakao',
  googleLoginEnabled: APP_RUNTIME.authMode === 'google',
} as const;
